// Actions for ladder
import {
	ICommonOptions,
	ILadderAPIOptions,
	ILadderWithPodium,
	IMonthLadderAPIOptions,
	IRoundAPIOptions,
	ITriviaLadderState,
} from "modules/reducers";
import {EnumTriviaLadders} from "modules/utils/enums";
import {createAction} from 'redux-act';


export const fetchLadder = createAction<ICommonOptions>();
export const fetchLadderPending = createAction();
export const fetchLadderSuccess = createAction<ITriviaLadderState>();
export const fetchLadderFailed = createAction();
export const clearLadder = createAction<EnumTriviaLadders>();
export const clearLadders = createAction<EnumTriviaLadders[]>();
export const clearAllLadders = createAction();

export const showLeaderboardModal = createAction();
export const hideLeaderboardModal = createAction();

export const fetchContestLadder = createAction<Partial<ILadderAPIOptions>>();
export const fetchContestLadderNoSpread = createAction<unknown>('fetchContestLadderNoSpread');
export const fetchContestLadderSuccess = createAction<ILadderWithPodium>();
export const fetchContestLadderFailed = createAction();

export const fetchContestByStoreLadder = createAction<Partial<ILadderAPIOptions>>();
export const fetchContestByStoreLadderNoSpread = createAction<unknown>('fetchContestByStoreLadderNoSpread');
export const fetchContestByStoreLadderSuccess = createAction<ILadderWithPodium>();
export const fetchContestByStoreLadderFailed = createAction();

export const fetchContestByStateLadder = createAction<Partial<ILadderAPIOptions>>();
export const fetchContestByStateLadderNoSpread = createAction<unknown>('fetchContestByStateLadderNoSpread');
export const fetchContestByStateLadderSuccess = createAction<ILadderWithPodium>();
export const fetchContestByStateLadderFailed = createAction();

export const fetchMonthLadder = createAction<Partial<IMonthLadderAPIOptions>>();
export const fetchMonthLadderNoSpread = createAction<unknown>('fetchMonthLadderNoSpread');
export const fetchMonthLadderSuccess = createAction<ILadderWithPodium>();
export const fetchMonthLadderFailed = createAction();

export const fetchMonthByStoreLadder = createAction<Partial<IMonthLadderAPIOptions>>();
export const fetchMonthByStoreLadderNoSpread = createAction<unknown>('fetchMonthByStoreLadderNoSpread');
export const fetchMonthByStoreLadderSuccess = createAction<ILadderWithPodium>();
export const fetchMonthByStoreLadderFailed = createAction();

export const fetchMonthByStateLadder = createAction<Partial<IMonthLadderAPIOptions>>();
export const fetchMonthByStateLadderNoSpread = createAction<unknown>('fetchMonthByStateLadderNoSpread');
export const fetchMonthByStateLadderSuccess = createAction<ILadderWithPodium>();
export const fetchMonthByStateLadderFailed = createAction();

export const fetchRoundLadder = createAction<Partial<IRoundAPIOptions>>();
export const fetchRoundLadderNoSpread = createAction<unknown>('fetchRoundLadderNoSpread');
export const fetchRoundLadderSuccess = createAction<ILadderWithPodium>();
export const fetchRoundLadderFailed = createAction();

export const fetchRoundStoreLadder = createAction<Partial<IRoundAPIOptions>>();
export const fetchRoundStoreLadderNoSpread = createAction<unknown>('fetchRoundStoreLadderNoSpread');
export const fetchRoundStoreLadderSuccess = createAction<ILadderWithPodium>();
export const fetchRoundStoreLadderFailed = createAction();

export const fetchRoundStateLadder = createAction<Partial<IRoundAPIOptions>>();
export const fetchRoundStateLadderNoSpread = createAction<unknown>('fetchRoundStateLadderNoSpread');
export const fetchRoundStateLadderSuccess = createAction<ILadderWithPodium>();
export const fetchRoundStateLadderFailed = createAction();

export const fetchCommonLadder = createAction<Partial<ILadderAPIOptions>>();
export const fetchCommonLadderSuccess = createAction<Partial<ITriviaLadderState["ladders"]>>();
export const fetchCommonLadderFailed = createAction();

export const fetchOverallLadder = createAction<Partial<ILadderAPIOptions>>();
export const fetchOverallLadderNoSpread = createAction<unknown>('fetchOverallLadderNoSpread');
export const fetchOverallLadderSuccess = createAction<ILadderWithPodium>();
export const fetchOverallLadderFailed = createAction();

export const fetchOverallByStoreLadder = createAction<Partial<ILadderAPIOptions>>();
export const fetchOverallByStoreLadderNoSpread = createAction<unknown>('fetchOverallByStoreLadderNoSpread');
export const fetchOverallByStoreLadderSuccess = createAction<ILadderWithPodium>();
export const fetchOverallByStoreLadderFailed = createAction();

export const fetchOverallByStateLadder = createAction<Partial<ILadderAPIOptions>>();
export const fetchOverallByStateLadderNoSpread = createAction<unknown>('fetchOverallByStateLadderNoSpread');
export const fetchOverallByStateLadderSuccess = createAction<ILadderWithPodium>();
export const fetchOverallByStateLadderFailed = createAction();


export const fetchTeamCommonLadder = createAction<Partial<ILadderAPIOptions>>();
export const fetchTeamCommonLadderSuccess = createAction<Partial<ITriviaLadderState["ladders"]>>();
export const fetchTeamCommonLadderFailed = createAction();

export const fetchTeamContestLadder = createAction<Partial<ILadderAPIOptions>>();
export const fetchTeamContestLadderNoSpread = createAction<Partial<ILadderAPIOptions>>('fetchTeamContestLadderNoSpread');
export const fetchTeamContestLadderSuccess = createAction<ILadderWithPodium>();
export const fetchTeamContestLadderFailed = createAction();

export const fetchTeamContestStoreLadder = createAction<Partial<ILadderAPIOptions>>();
export const fetchTeamContestStoreLadderNoSpread = createAction<unknown>('fetchOverallByStoreLadderNoSpread');
export const fetchTeamContestStoreLadderSuccess = createAction<ILadderWithPodium>();
export const fetchTeamContestStoreLadderFailed = createAction();


export const fetchTeamContestStateLadder = createAction<Partial<ILadderAPIOptions>>();
export const fetchTeamContestStateLadderNoSpread = createAction<unknown>('fetchOverallByStoreLadderNoSpread');
export const fetchTeamContestStateLadderSuccess = createAction<ILadderWithPodium>();
export const fetchTeamContestStateLadderFailed = createAction();

export const fetchTeamMonthLadder = createAction<Partial<IMonthLadderAPIOptions>>();
export const fetchTeamMonthLadderNoSpread = createAction<Partial<IMonthLadderAPIOptions>>('fetchTeamMonthLadderNoSpread');
export const fetchTeamMonthLadderSuccess = createAction<ILadderWithPodium>();
export const fetchTeamMonthLadderFailed = createAction();

export const fetchTeamMonthByStateLadder = createAction<Partial<IMonthLadderAPIOptions>>();
export const fetchTeamMonthByStateLadderNoSpread = createAction<unknown>('fetchTeamMonthByStateLadderNoSpread');
export const fetchTeamMonthByStateLadderSuccess = createAction<ILadderWithPodium>();
export const fetchTeamMonthByStateLadderFailed = createAction();

export const fetchTeamMonthByStoreLadder = createAction<Partial<IMonthLadderAPIOptions>>();
export const fetchTeamMonthByStoreLadderNoSpread = createAction<unknown>('fetchTeamMonthByStoreLadderNoSpread');
export const fetchTeamMonthByStoreLadderSuccess = createAction<ILadderWithPodium>();
export const fetchTeamMonthByStoreLadderFailed = createAction();

export const fetchTeamSeasonLadder = createAction<Partial<ILadderAPIOptions>>();
export const fetchTeamSeasonLadderNoSpread = createAction<unknown>('fetchTeamSeasonLadderNoSpread');
export const fetchTeamSeasonLadderSuccess = createAction<ILadderWithPodium>();
export const fetchTeamSeasonLadderFailed = createAction();
